import Super from './paragraph-text-input';
import classic from 'ember-classic-decorator';

@classic
export default class SharedQuestionnaireParagraphTextReview extends Super {}
